import { dollarsToSatoshis, satoshisToDollars } from "../../utils";
import { OrgContractDataTypeQualifierType, OrgContractDisplayTypeQualifier, OrgContractMadSupplyChargeType, OrgContractMediaTypeQualifier, OrgContractStatus, OrgContractVideoTypeQualifier, ServiceOrgContractDataTypeQualifierType, ServiceOrgContractDisplayTypeQualifier, ServiceOrgContractMadSupplyChargeType, ServiceOrgContractMediaTypeQualifier, ServiceOrgContractStatus, ServiceOrgContractVideoTypeQualifier } from "./types";
import { convertCurrencyValue } from "./utils";
export const serviceToOrgContractMediaType = (mediaType) => {
    switch (mediaType) {
        case ServiceOrgContractMediaTypeQualifier.VIDEO:
            return OrgContractMediaTypeQualifier.VIDEO;
        case ServiceOrgContractMediaTypeQualifier.AUDIO:
            return OrgContractMediaTypeQualifier.AUDIO;
        case ServiceOrgContractMediaTypeQualifier.DISPLAY:
            return OrgContractMediaTypeQualifier.DISPLAY;
        default:
            return undefined;
    }
};
export const serviceToOrgContractVideoType = (videoType) => {
    switch (videoType) {
        case ServiceOrgContractVideoTypeQualifier.OTT:
            return OrgContractVideoTypeQualifier.OTT;
        case ServiceOrgContractVideoTypeQualifier.OLV:
            return OrgContractVideoTypeQualifier.OLV;
        case ServiceOrgContractVideoTypeQualifier.OTV:
            return OrgContractVideoTypeQualifier.OTV;
        case ServiceOrgContractVideoTypeQualifier.DOOH:
            return OrgContractVideoTypeQualifier.DOOH;
        default:
            return undefined;
    }
};
export const serviceToOrgContractDisplayType = (displayType) => {
    switch (displayType) {
        case ServiceOrgContractDisplayTypeQualifier.DT_DOOH:
            return OrgContractDisplayTypeQualifier.DT_DOOH;
        case ServiceOrgContractDisplayTypeQualifier.TRADITIONAL:
            return OrgContractDisplayTypeQualifier.TRADITIONAL;
        default:
            return undefined;
    }
};
export const serviceToOrgContractDataTypeQualifierType = (dataType) => {
    switch (dataType) {
        case ServiceOrgContractDataTypeQualifierType.RETARGETING:
            return OrgContractDataTypeQualifierType.RETARGETING;
        case ServiceOrgContractDataTypeQualifierType.FIRST_PARTY:
            return OrgContractDataTypeQualifierType.FIRST_PARTY;
        case ServiceOrgContractDataTypeQualifierType.THIRD_PARTY:
            return OrgContractDataTypeQualifierType.THIRD_PARTY;
        default:
            return undefined;
    }
};
export const serviceToOrgContractStatus = (status) => {
    switch (status) {
        case ServiceOrgContractStatus.DRAFT:
            return OrgContractStatus.DRAFT;
        case ServiceOrgContractStatus.READY:
            return OrgContractStatus.READY;
        case ServiceOrgContractStatus.ACTIVE:
            return OrgContractStatus.ACTIVE;
        case ServiceOrgContractStatus.EXPIRED:
            return OrgContractStatus.EXPIRED;
        case ServiceOrgContractStatus.TERMINATED:
            return OrgContractStatus.TERMINATED;
        default:
            return undefined;
    }
};
export const serviceToOrgContractMadSupplyChargeType = (madSupplyChargeType) => {
    switch (madSupplyChargeType) {
        case ServiceOrgContractMadSupplyChargeType.RATE_CARD:
            return OrgContractMadSupplyChargeType.RATE_CARD;
        case ServiceOrgContractMadSupplyChargeType.COST_PLUS:
            return OrgContractMadSupplyChargeType.COST_PLUS;
        default:
            return undefined;
    }
};
export const serviceToOrgContractCreativeDurationMultiplier = (multiplier) => {
    return {
        fifteenSeconds: multiplier?.fifteen_seconds ?? 0 / 100,
        thirtySeconds: multiplier?.thirty_seconds ?? 0 / 100,
        sixtySeconds: multiplier?.sixty_seconds ?? 0 / 100,
        ninetySeconds: multiplier?.ninety_seconds ?? 0 / 100
    };
};
export const serviceToOrgContractAdditionalMediaFees = (additionalMediaFees) => {
    return additionalMediaFees?.map((fee) => ({
        name: fee.name,
        fee: {
            type: fee.fee?.type,
            val: convertCurrencyValue(fee.fee?.type, fee.fee?.val, "toClient")
        },
        orgQualifier: {
            org_id: fee.org_qualifier?.org_id
        },
        mediaTypeQualifier: {
            mediaType: serviceToOrgContractMediaType(fee.media_type_qualifier?.media_type),
            videoType: serviceToOrgContractVideoType(fee.media_type_qualifier?.video_type),
            displayType: serviceToOrgContractDisplayType(fee.media_type_qualifier?.display_type)
        }
    }));
};
export const serviceToOrgContractAdditionalDataFees = (additionalDataFees) => {
    return additionalDataFees?.map((fee) => ({
        name: fee.name,
        fee: {
            type: fee.fee?.type,
            val: convertCurrencyValue(fee.fee?.type, fee.fee?.val, "toClient")
        },
        dataTypeQualifier: {
            type: serviceToOrgContractDataTypeQualifierType(fee.data_type_qualifier?.type),
            dmpId: fee.data_type_qualifier?.dmp_id
        },
        mediaTypeQualifier: {
            mediaType: serviceToOrgContractMediaType(fee.media_type_qualifier?.media_type),
            videoType: serviceToOrgContractVideoType(fee.media_type_qualifier?.video_type),
            displayType: serviceToOrgContractDisplayType(fee.media_type_qualifier?.display_type)
        }
    }));
};
export const serviceToOrgContractSupplementalFees = (supplementalFees) => {
    return supplementalFees?.map((fee) => ({
        name: fee.name,
        fee: {
            type: fee.fee?.type,
            val: convertCurrencyValue(fee.fee?.type, fee.fee?.val, "toClient")
        },
        orgQualifier: {
            org_id: fee.org_qualifier?.org_id
        },
        mediaTypeQualifier: {
            mediaType: serviceToOrgContractMediaType(fee.media_type_qualifier?.media_type),
            videoType: serviceToOrgContractVideoType(fee.media_type_qualifier?.video_type),
            displayType: serviceToOrgContractDisplayType(fee.media_type_qualifier?.display_type)
        }
    }));
};
export const serviceToOrgContract = (base) => {
    const { id, org_id: orgId, status: orgStatus, valid_from: { seconds: validFrom } = { seconds: 0 }, valid_to: { seconds: validTo } = { seconds: 0 }, created_at: { seconds: createdAt } = { seconds: 0 }, updated_at: { seconds: updatedAt } = { seconds: 0 }, created_user_id: createdUserId, updated_user_id: updatedUserId, madsupply_charge_type, cost_plus_margin_pct, over_delivery, o_and_o_fee, deals_fee, creative_duration_multipliers, additional_media_fees, additional_data_fees, supplemental_fees } = base;
    const overDelivery = {
        targetPct: over_delivery?.target_pct,
        cpm: typeof over_delivery?.cpm === "number" ? satoshisToDollars(over_delivery?.cpm) : 0 //convert to satoshi
    };
    const oAndOFee = {
        type: o_and_o_fee?.type,
        val: convertCurrencyValue(o_and_o_fee?.type, o_and_o_fee?.val, "toClient")
    };
    const dealsFee = {
        type: deals_fee?.type,
        val: convertCurrencyValue(deals_fee?.type, deals_fee?.val, "toClient")
    };
    const status = serviceToOrgContractStatus(orgStatus);
    const madsupplyChargeType = serviceToOrgContractMadSupplyChargeType(madsupply_charge_type);
    const creativeDurationMultipliers = serviceToOrgContractCreativeDurationMultiplier(creative_duration_multipliers);
    const additionalMediaFees = serviceToOrgContractAdditionalMediaFees(additional_media_fees);
    const additionalDataFees = serviceToOrgContractAdditionalDataFees(additional_data_fees);
    const supplementalFees = serviceToOrgContractSupplementalFees(supplemental_fees);
    return {
        id,
        orgId,
        ...("status" in base && { status }),
        ...("valid_from" in base && { validFrom: new Date(validFrom * 1000) }),
        ...("valid_to" in base && { validTo: new Date(validTo * 1000) }),
        ...("created_at" in base && { createdAt: new Date(createdAt * 1000) }),
        ...("updated_at" in base && { updatedAt: new Date(updatedAt * 1000) }),
        createdUserId,
        updatedUserId,
        ...("madsupply_charge_type" in base && { madsupplyChargeType }),
        costPlusMarginPct: (cost_plus_margin_pct ?? 0) / 100,
        overDelivery,
        oAndOFee,
        dealsFee,
        ...("creative_duration_multipliers" in base && { creativeDurationMultipliers }),
        ...("additional_media_fees" in base && { additionalMediaFees }),
        ...("additional_data_fees" in base && { additionalDataFees }),
        ...("supplemental_fees" in base && { supplementalFees })
    };
};
export const orgContractToServiceMediaType = (mediaType) => {
    switch (mediaType) {
        case OrgContractMediaTypeQualifier.VIDEO:
            return ServiceOrgContractMediaTypeQualifier.VIDEO;
        case OrgContractMediaTypeQualifier.AUDIO:
            return ServiceOrgContractMediaTypeQualifier.AUDIO;
        case OrgContractMediaTypeQualifier.DISPLAY:
            return ServiceOrgContractMediaTypeQualifier.DISPLAY;
        default:
            return undefined;
    }
};
export const orgContractToServiceVideoType = (videoType) => {
    switch (videoType) {
        case OrgContractVideoTypeQualifier.OTT:
            return ServiceOrgContractVideoTypeQualifier.OTT;
        case OrgContractVideoTypeQualifier.OLV:
            return ServiceOrgContractVideoTypeQualifier.OLV;
        case OrgContractVideoTypeQualifier.OTV:
            return ServiceOrgContractVideoTypeQualifier.OTV;
        case OrgContractVideoTypeQualifier.DOOH:
            return ServiceOrgContractVideoTypeQualifier.DOOH;
        default:
            return undefined;
    }
};
export const orgContractToServiceDisplayType = (displayType) => {
    switch (displayType) {
        case OrgContractDisplayTypeQualifier.DT_DOOH:
            return ServiceOrgContractDisplayTypeQualifier.DT_DOOH;
        case OrgContractDisplayTypeQualifier.TRADITIONAL:
            return ServiceOrgContractDisplayTypeQualifier.TRADITIONAL;
        default:
            return undefined;
    }
};
export const orgContractToServiceDataTypeQualifierType = (dataType) => {
    switch (dataType) {
        case OrgContractDataTypeQualifierType.RETARGETING:
            return ServiceOrgContractDataTypeQualifierType.RETARGETING;
        case OrgContractDataTypeQualifierType.FIRST_PARTY:
            return ServiceOrgContractDataTypeQualifierType.FIRST_PARTY;
        case OrgContractDataTypeQualifierType.THIRD_PARTY:
            return ServiceOrgContractDataTypeQualifierType.THIRD_PARTY;
        default:
            return undefined;
    }
};
export const orgContractToServiceStatus = (status) => {
    switch (status) {
        case OrgContractStatus.DRAFT:
            return ServiceOrgContractStatus.DRAFT;
        case OrgContractStatus.READY:
            return ServiceOrgContractStatus.READY;
        case OrgContractStatus.ACTIVE:
            return ServiceOrgContractStatus.ACTIVE;
        case OrgContractStatus.EXPIRED:
            return ServiceOrgContractStatus.EXPIRED;
        case OrgContractStatus.TERMINATED:
            return ServiceOrgContractStatus.TERMINATED;
        default:
            return undefined;
    }
};
export const orgContractToServiceMadSupplyChargeType = (madSupplyChargeType) => {
    switch (madSupplyChargeType) {
        case OrgContractMadSupplyChargeType.RATE_CARD:
            return ServiceOrgContractMadSupplyChargeType.RATE_CARD;
        case OrgContractMadSupplyChargeType.COST_PLUS:
            return ServiceOrgContractMadSupplyChargeType.COST_PLUS;
        default:
            return undefined;
    }
};
export const orgContractToServiceCreativeDurationMultiplier = (multiplier) => {
    return {
        fifteen_seconds: multiplier?.fifteenSeconds ?? 0 * 100,
        thirty_seconds: multiplier?.thirtySeconds ?? 0 * 100,
        sixty_seconds: multiplier?.sixtySeconds ?? 0 * 100,
        ninety_seconds: multiplier?.ninetySeconds ?? 0 * 100
    };
};
export const orgContractToServiceAdditionalMediaFees = (additionalMediaFees) => {
    return additionalMediaFees?.map((fee) => ({
        name: fee.name,
        fee: {
            type: fee.fee.type,
            val: convertCurrencyValue(fee.fee.type, fee.fee.val, "toService")
        },
        org_qualifier: {
            org_id: fee.orgQualifier.org_id
        },
        media_type_qualifier: {
            media_type: orgContractToServiceMediaType(fee.mediaTypeQualifier.mediaType),
            video_type: orgContractToServiceVideoType(fee.mediaTypeQualifier.videoType),
            display_type: orgContractToServiceDisplayType(fee.mediaTypeQualifier.displayType)
        }
    }));
};
export const orgContractToServiceAdditionalDataFees = (additionalDataFees) => {
    return additionalDataFees?.map((fee) => ({
        name: fee.name,
        fee: {
            type: fee.fee.type,
            val: convertCurrencyValue(fee.fee.type, fee.fee.val, "toService")
        },
        data_type_qualifier: {
            type: orgContractToServiceDataTypeQualifierType(fee.dataTypeQualifier.type),
            dmp_id: fee.dataTypeQualifier.dmpId
        },
        media_type_qualifier: {
            media_type: orgContractToServiceMediaType(fee.mediaTypeQualifier.mediaType),
            video_type: orgContractToServiceVideoType(fee.mediaTypeQualifier.videoType),
            display_type: orgContractToServiceDisplayType(fee.mediaTypeQualifier.displayType)
        }
    }));
};
export const orgContractToServiceSupplementalFees = (supplementalFees) => {
    return supplementalFees?.map((fee) => ({
        name: fee.name,
        fee: {
            type: fee.fee.type,
            val: convertCurrencyValue(fee.fee.type, fee.fee.val, "toService")
        },
        org_qualifier: {
            org_id: fee.orgQualifier.org_id
        },
        media_type_qualifier: {
            media_type: orgContractToServiceMediaType(fee.mediaTypeQualifier.mediaType),
            video_type: orgContractToServiceVideoType(fee.mediaTypeQualifier.videoType),
            display_type: orgContractToServiceDisplayType(fee.mediaTypeQualifier.displayType)
        }
    }));
};
export const orgContractToService = (base) => {
    const { id, orgId: org_id, status, validFrom, validTo, createdAt, updatedAt, createdUserId: created_user_id, updatedUserId: updated_user_id, madsupplyChargeType, costPlusMarginPct, overDelivery, oAndOFee, dealsFee, creativeDurationMultipliers, additionalMediaFees, additionalDataFees, supplementalFees } = base;
    const over_delivery = {
        target_pct: overDelivery?.targetPct,
        cpm: typeof overDelivery?.cpm === "number" ? dollarsToSatoshis(overDelivery?.cpm) : undefined
    };
    const o_and_o_fee = {
        type: oAndOFee?.type,
        val: convertCurrencyValue(oAndOFee?.type, oAndOFee?.val, "toService")
    };
    const deals_fee = {
        type: dealsFee?.type,
        val: convertCurrencyValue(dealsFee?.type, dealsFee?.val, "toService")
    };
    const orgStatus = orgContractToServiceStatus(status);
    const madsupply_charge_type = orgContractToServiceMadSupplyChargeType(madsupplyChargeType);
    const creative_duration_multipliers = orgContractToServiceCreativeDurationMultiplier(creativeDurationMultipliers);
    const additional_media_fees = orgContractToServiceAdditionalMediaFees(additionalMediaFees);
    const additional_data_fees = orgContractToServiceAdditionalDataFees(additionalDataFees);
    const supplemental_fees = orgContractToServiceSupplementalFees(supplementalFees);
    return {
        id,
        org_id,
        ...("status" in base && { status: orgStatus }),
        valid_from: validFrom ? { seconds: Math.floor(validFrom.getTime() / 1000) } : undefined,
        valid_to: validTo ? { seconds: Math.floor(validTo.getTime() / 1000) } : undefined,
        created_at: createdAt ? { seconds: Math.floor(createdAt.getTime() / 1000) } : undefined,
        updated_at: updatedAt ? { seconds: Math.floor(updatedAt.getTime() / 1000) } : undefined,
        created_user_id,
        updated_user_id,
        ...("madsupplyChargeType" in base && { madsupply_charge_type }),
        cost_plus_margin_pct: costPlusMarginPct !== undefined ? costPlusMarginPct * 100 : undefined,
        over_delivery,
        o_and_o_fee,
        deals_fee,
        ...("creativeDurationMultipliers" in base && { creative_duration_multipliers }),
        ...("additionalMediaFees" in base && { additional_media_fees }),
        ...("additionalDataFees" in base && { additional_data_fees }),
        ...("supplementalFees" in base && { supplemental_fees })
    };
};
//# sourceMappingURL=index.js.map